module.exports = __webpack_public_path__ + "media/images/coauthors-docs-1ff6d4a6042b2c8f8ccfd76b7990196c.png";